import axiosInstance from '../../config/axios';
import type { APIResp } from '../../types/APIService';
import type { DentalMaterial, NewDentalMaterial } from '../../types/DentalMaterial';

const API_ENDPOINT = '/materials' as const;

export async function getAllmaterials(): Promise<DentalMaterial[]> {
  try {
    const res = await axiosInstance.get<APIResp<DentalMaterial[]>>(API_ENDPOINT);
    return res.data.data;
  }
  catch {
    return [];
  }
}

export async function postMaterial(body: NewDentalMaterial) {
  try {
    await axiosInstance.post(API_ENDPOINT, body);
    return true;
  }
  catch {
    return false;
  }
}

export async function updateMaterial({ id, ...body }: DentalMaterial) {
  try {
    await axiosInstance.put(`${API_ENDPOINT}/${id}`, body);
    return true;
  }
  catch {
    return false;
  }
}

export async function deleteMaterial(id: number) {
  try {
    await axiosInstance.delete(`${API_ENDPOINT}/${id}`);
    return true;
  }
  catch {
    return false;
  }
}

export async function reorderMaterials(ids: number[]) {
  try {
    await axiosInstance.post(`${API_ENDPOINT}/bulk-update`, ids);
    return true;
  }
  catch {
    return false;
  }
}
